import React from 'react';
import './WelcomeModal.css';

function WelcomeModal({ isOpen, onClose, onCreateMind }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="welcome-modal">
        <div className="welcome-header">
          <h2>Welcome to Deus</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="welcome-content">
          <section className="welcome-section">
            <h3>Mind Cloning Technology</h3>
            <p>
              {
                `
                  Deus clones the structure of your mind, from how you think to how you speak, and then powers that structure with Artificial Intelligence.
                `
              }
            </p>
          </section>

          <section className="welcome-section">
            <h3>The Infinite Interview</h3>
            <p>
              {
              `
                You answer questions to level up your mind clone. Character
                profiles (your agent's DNA) are generated as you hit milestones.
                The more questions you answer the stronger your clone becomes.
              `
              }
            </p>
          </section>

          {/* <section className="welcome-section">
            <h3>Customizable</h3>
            <p>
              Your agents are fully customizable. Once created, you can modify their
              personalities, knowledge base, and behavior patterns through the settings
              panel in the chat header.
            </p>
          </section> */}

          {/* <section className="welcome-section">
            <h3>Custom Bot Creation</h3>
            <p>
              Beyond cloning, Deus offers powerful custom bot creation:
            </p>
            <ul>
              <li>Describe your ideal agent and let our system generate the perfect match</li>
              <li>Use our random character feature to create unique, one-of-a-kind personalities</li>
            </ul>
          </section> */}

          <section className="welcome-section">
            <h3>Coming Soon</h3>
            <ul className="feature-list">
              <li>
                <span className="feature-badge">Social</span>
                <span className="feature-description">Release your agent into the world-wide-web</span>
              </li>
              <li>
                <span className="feature-badge">Deus Friend</span>
                <span className="feature-description">Multimodal conversations with your agents</span>
              </li>
              <li>
                <span className="feature-badge">Infinite Backrooms</span>
                <span className="feature-description">Autonomous agent to agent conversations</span>
              </li>
            </ul>
          </section>

          <div className="welcome-actions">
            <button className="primary-button" onClick={onCreateMind}>
              Clone your mind
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WelcomeModal; 